export default {
      id: "success-usage",
      viewBox: "0 0 25 25",
      url: __webpack_public_path__ + "img/icons.ece5aa3c.svg#success",
      toString: function () {
        return this.url;
      }
    }